export * from './auth';
export * from './auth.module';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/auth/public_api.js
// module id = 294
// module chunks = 4